/*
    AutoStick.js
*/
;(function ($) {
  var defaults = {
    wrapperElement: 'body',
    beforeElement: null,
    marginTop: 20,
    marginBottom: 0,
    marginLeft: 10,
    scrollMargin: 0,
    enableCondition: function () {
      return true
    }
  }
  $.fn.extend({
    autoStick: function (opt) {
      if ($(this).length === 0) {
        return
      }
      opt = $.extend(defaults, opt)
      opt.fixTop = opt.fixTop || opt.marginTop
      var $wrapper = $(opt.wrapperElement)
      $wrapper.css('position', 'relative')
      var $this = $(this)
      var that = this
      $(window).scroll(function () {
        if (!opt.enableCondition.apply(that)) {
          $this.css('position', 'static')
          $this.css('marginTop', opt.marginTop)
          return true
        }
        $this.css('marginTop', 0)
        var scroll = $(this).scrollTop()
        var scrollMargin = opt.scrollMargin
        var beforeElement = opt.beforeElement
        var beforeHeight = $wrapper.offset().top
        if (beforeElement) {
          beforeHeight = $(beforeElement).offset().top + $(beforeElement).outerHeight()
          $this.width($(beforeElement).width())
        }
        if (beforeHeight + $this.height() * 2 > $wrapper.outerHeight() + $wrapper.offset().top) {
          $this.css('position', 'static')
          return
        }
        if (scroll > beforeHeight - scrollMargin) {
          if (scroll + $this.outerHeight() + opt.marginBottom + opt.fixTop > $wrapper.offset().top + $wrapper.outerHeight()) {
            var bottom = $wrapper.outerHeight() - $this.outerHeight()
            $this.css('position', 'absolute')
            $this.css('top', bottom - opt.marginBottom)
            if (opt.marginRight) {
              $this.css('right', opt.marginRight)
            }else {
              $this.css('left', opt.marginLeft)
            }
          }else {
            $this.css('position', 'fixed')
            $this.css('top', opt.fixTop)
            if (opt.marginRight) {
              $this.css('right', $wrapper.offset().left + opt.marginRight)
            }else {
              $this.css('left', $wrapper.offset().left + opt.marginLeft)
            }
          }
        }else {
          $this.css('position', 'absolute')
          if (beforeHeight) {
            $this.css('top', beforeHeight - $wrapper.offset().top + opt.marginTop)
            if (opt.marginRight) {
              $this.css('right', opt.marginRight)
            }else {
              $this.css('left', opt.marginLeft)
            }
          }
        }
      }).scroll()
      $(window).resize(function () {
        $(window).scroll()
      })
    }
  })
})(jQuery)
